import { render, staticRenderFns } from "./ClienteModal.vue?vue&type=template&id=9be498bc&scoped=true"
import script from "./ClienteModal.vue?vue&type=script&lang=js"
export * from "./ClienteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be498bc",
  null
  
)

export default component.exports